import React from 'react';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Task } from '@models/task.model';
import { useTranslation } from '@hooks/useTranslation';

interface TaskNameProps {
  task?: Task | null;
  taskId?: string;
  label?: string;
  size?: 'sm' | 'base';
  onOpenTask?: (taskId: string) => void;
}

export const TaskName: React.FC<TaskNameProps> = ({
  task,
  taskId,
  label,
  size = 'base',
  onOpenTask,
}) => {
  const tActivityCards = useTranslation('activityCards');
  const resolvedLabel = label ?? tActivityCards.taskLabel;
  const textBase = size === 'sm' ? 'text-sm' : 'text-base';
  const labelBase = size === 'sm' ? 'text-sm' : 'text-base';
  const resolvedId = taskId || task?.taskId || (task as any)?.id;

  const handleClick = () => {
    if (resolvedId && onOpenTask) onOpenTask(resolvedId);
  };

  return (
    <div className="flex gap-1 items-baseline">
      <p className={`${labelBase} text-neutral-800`}>{resolvedLabel}</p>
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (!taskId) return;
          handleClick();
        }}
        className={`${textBase} flex items-center cursor-pointer hover:underline text-indigo-600`}>
        {task?.name || task?.taskId || tActivityCards.notAvailable}
        <span className="text-indigo-600">
          <RemoveRedEyeIcon
            fontSize="small"
            className="ml-1 -mt-1 text-indigo-600"
          />
        </span>
      </div>
    </div>
  );
};

export default TaskName;
